export function scheduleSlider() {
    let $scheduleContainer = $(".schedule-slider");
    let $scheduleDate = $scheduleContainer.find(".schedule-date-slider");
    let $scheduleEvent = $scheduleContainer.find(".schedule-event-slider");
    let $dateArrowButtons = $scheduleContainer.find(".schedule-event-date-arrow");
    let prevButtonDate = $dateArrowButtons.find(".prev");
    let nextButtonDate = $dateArrowButtons.find(".next");

    function getPrevNextDates(curentSlideId){
        const currentSlideDate = $($scheduleDate.find(`.slick-slide[data-slick-index=${curentSlideId}]`));
        const prevDate = currentSlideDate.prev(".slick-slide").text();
        const nextDate = currentSlideDate.next(".slick-slide").text();
        
        $(prevButtonDate).text(prevDate);
        $(nextButtonDate).text(nextDate);
    }
    
    $scheduleDate.on("init", function () {
        getPrevNextDates(0);
    });

    $scheduleDate.slick({
        slidesToScroll: 1,
        slidesToShow: 1.5,
        asNavFor: ".schedule-event-slider",
        dots: false,
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 2.5,
                }
            },{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });

    $scheduleEvent.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        // fade: true,
        asNavFor: ".schedule-date-slider",
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 568,
                settings: {
                    arrows: true,
                }
            }
        ]
    });


    $scheduleDate.on("afterChange", function (event, slick, currentSlide) {
        getPrevNextDates(currentSlide);
    });

    $(prevButtonDate).on("click", function (e){ 
        e.preventDefault(); 
        $scheduleEvent.slick("slickPrev");
    });
  
    $(nextButtonDate).on("click", function (e){
        e.preventDefault(); 
        $scheduleEvent.slick("slickNext");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scheduleSlider.js